import { graphql } from "@/lib/gql/__generated__";

export const HotelI18n_HotelInfoSettingsPage_Query = graphql(`
	query HotelI18n_HotelInfoSettingsPage($hotelID: ID!, $lang: LangCode!) {
		hotelI18n(hotelID: $hotelID, lang: $lang) {
			id
			lang
			companyID
			hotelID
			name
			catchCopy
			address {
				nationality
				postalCode
				state
				pref
				city
				town
				other
			}
			article {
				bucket
				key
				region
				mimeType
				fileName
			}
		}
	}
`);
